import { number } from 'prop-types';
import { applySpec } from 'ramda';
import React from 'react';

import { useAppState } from '@ezugi/bootstrap/src/hooks/useAppState';

import { roadmapSelector, roadmapSelectorOddAndEven } from '../../store/selectors/statistics';
import Cell from './Cell';
import { Container, Column } from './style';

const spec = applySpec({
  roadmap: roadmapSelector,
  roadmapOddAndEven: roadmapSelectorOddAndEven,
});

export default function Roadmap({ roadMapOption, cellSize }) {
  const [ { roadmap = [], roadmapOddAndEven } ] = useAppState(spec);

  const roadmapData = roadMapOption === 0 ? roadmap : roadmapOddAndEven;

  return (
    <Container>
      {roadmapData.map((column, index) => (
        <Column key={index}>
          {column.map((cell, cellIndex) => (
            <Cell
              size={cellSize}
              key={cell.roundId || cellIndex}
              {...cell}
            />
          ))}
        </Column>
      ))}
    </Container>
  );
}

Roadmap.propTypes = {
  cellSize: number,
  roadMapOption: number,
};
